import { GameName } from "../types";

type State = Partial<Record<GameName, string[]>>;

type RecentCharactersReducerAction = {
  type: "SET_RECENT_CHARACTERS";
  game: GameName;
  character: string;
};

const defaultState: State = {};

export const recentCharactersReducer = (
  state: State = defaultState,
  action: RecentCharactersReducerAction
): State => {
  switch (action.type) {
    case "SET_RECENT_CHARACTERS": {
      const { game, character } = action;
      const prev = state[game] ?? [];

      // Remove the character if it exists, then append
      const newList = [...prev.filter((c) => c !== character), character].slice(-4);

      return {
        ...state,
        [game]: newList,
      };
    }
    default:
      return state;
  }
};
